<template>
  <div class="index" v-cloak>
  <div class="syTitleHead">
    <div class="title acea-row row-between-wrapper">
      <div class="text">
        <div class="name">欢迎{{strName}}老师进入{{strSchool}}校园收费通</div>
      </div>
    </div>
    </div>
    <div class="wrapper" v-if="resData.length > 0">
      <SYTradeList :good-list="resData" :is-sort="false"></SYTradeList>
    </div>
    <div class="title acea-row row-between-wrapper" v-if="resData.length < 1 && haveBind == true">
      <div class="noData">
        当前学校暂无收费项目
      </div>
    </div>

    <div class="acea-row row-between-wrapper" v-if="haveBind == false">
        <img src="back.jpg" class="imageStyle" />
    </div>

    <div style="height:1.2rem;"></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import SYTradeList from "@components/SYTradeList";


import { getHomeData, getShare, toAuth, getOpenId, getSchoolByOpenId} from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAppMessage, openShareTimeline, ready } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { parseQuery } from "@utils/index";

import { oAuth, auth, wechatConfig} from "@libs/wechat";
import { log } from 'util';

const HAS_COUPON_WINDOW = "has_coupon_window";

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    SYTradeList
   },
  props: {},
  data: function() {
    return {
      haveBind: false,
      schoolId: "",
      strName:"",
      strSchool:"",
      resData: [],
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: []
  
    };
  },
  mounted: function() {
    // test
    // cookie.set("lishu-openid", "ojHwQv8zV_OfXT5-wA0TZ26YeFmA");

    let that = this;
    let param = parseQuery();

    this.codeFail = 0;

    this.interval = null;//计时器
 
    this.start();

    cookie.set("lishu-haveInfo", "0");
    cookie.set("lishu-school", "");
    cookie.set("lishu-name", "");
      
    // if (openid != null) {
    //   console.log("shiyi openid is "+openid);
    //   wechatConfig();
    //   start();

    // }else{
        if (param.code != null) {
          log('param.code  '+param.code);
          wechatConfig();

          getOpenId(param.code).then((data, res) => {

            if (data.code == 0) {
              console.log("open id--");
              console.log(data.data.openId);

              that.stop();

              if (data.data && data.data.openId && data.data.openId.length > 1) {
                cookie.set("lishu-openid", data.data.openId);

                if (data.data.state == "1") {
                  getSchoolByOpenId(data.data.openId).then((dataSchool, res) => {
                    if (dataSchool.code == 0) {
                        cookie.set("lishu-school", dataSchool.data.schoolName);
                        cookie.set("lishu-name", dataSchool.data.teacherName);
                        cookie.set("lishu-schoolId", dataSchool.data.schoolId);
                        cookie.set("lishu-haveInfo", "1");
                        that.schoolId = dataSchool.data.schoolId;
                        that.strSchool = dataSchool.data.schoolName;
                        that.strName = dataSchool.data.teacherName;

                        that.$dialog.toast({ mes: "欢迎"+dataSchool.data.schoolName+"-"+dataSchool.data.teacherName+"老师登录校园收费通" });

                        that.haveBind = true;

                        getHomeData(1, 100, that.schoolId).then((data, res) => {
                          console.log(data);
                          if (data.code == 0) {
                            that.$set(that, "resData", data.data.schoolList);
                            console.log("resData");
                          }
                          console.log(that.resData);
                        }).catch((result)=>{ 
                            console.log('error:',result);
                          }
                        );

                    }else{
                      that.$dialog.toast({ mes: dataSchool.msg });
                    }
                  }).catch(()=>{ 
                      console.log('getSchoolByOpenId error:');
                    }
                  );
                }else{
                  that.$router.push({
                      path: "/user/binding"
                  });
                }
              }else{
                that.$dialog.toast({ mes: "openid 网络异常" });
              }

            }else if(data.code == 302){
              // get code
              that.codeFail = 1;
            }else{
              that.stop();
              log("code --"+data.code);
              that.$dialog.toast({ mes: data.msg });
            }

              

              // that.$dialog.confirm({
              //   mes: "lishu-openid "+data.data.result,
              //   opts: [
              //     {
              //       txt: "确认",
              //       color: false,
              //       callback: () => {
              //       }
              //     }
              //   ]
              // });

          }).catch((result)=>{ 
              console.log('error:',result);
            }
          );
        }else{
          if (isWeixin()) {
                log('isWeixin---oAuth--');
                oAuth();
          }
        }

        
  },
  methods: {
    stop(){
      let that = this;
				clearInterval(that.interval);
				that.interval = null;
      },
    start(){//启动计时器函数
        let that = this;
				if(that.interval!=null){//判断计时器是否为空
					clearInterval(that.interval);
					that.interval=null;
				}
				that.interval = setInterval(that.overs,1000);//启动计时器，调用overs函数，
      },
    overs(){
        let that = this;
        if (that.codeFail == 1){
          stop();
          window.location.href = "http://datum.lishuedu.com/";
        }
			},
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    setOpenShare: function() {

      log("setOpenShare -- ");
      getShare().then(res => {
        var data = res.data.data;
        var configAppMessage = {
          desc: data.synopsis,
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        var configTimeline = {
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        if (isWeixin() === true) {
          ready().then(() => {
            openShareAppMessage(configAppMessage).then(() => {});
            openShareTimeline(configTimeline).then(() => {});
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.index {
  background-color: #fff;
}

.listView {
  height: 80%;
}

.noData {
  font-size: 20px;
  color: #888888;
  margin:0 auto;
  margin-top: 50%;
}

.imageStyle {
  /* width: 100%;
  height: 100%; */
  /* overflow: hidden; */
  margin:0 auto;
  margin-top: 50%;
}

.syTitleHead {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: 2%;
  margin-bottom: 2%;
  width: 92%;
  color: rgb(15, 15, 15);
  font-size: 16px;
}

.syTitle {
  background-color: #e93323;
  color: #fff;
  font-size: 20px;
}
</style>
